import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { config } from '../../../../config';
import { Note } from './note.model';

interface NoteResponse {
  data: Note;
}

@Injectable()
export class NoteService {
  constructor(private http: HttpClient) {}

  update(note: Partial<Note>) {
    return this.http
      .patch<NoteResponse>(`${config.apiLocation}/v1/notes/${note.id}`, note)
      .map(res => res.data);
  }

  delete(note: Note) {
    return this.http.delete<void>(`${config.apiLocation}/v1/notes/${note.id}`)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/notes/note.service.ts